import { useState } from "react";
import "./announcementBanner.scss";

const MSD_URL = "https://msd.milestonesys.com";

const AnnouncementBanner = () => {
    const [dismissed, setDismissed] = useState(false);

    if (dismissed) {
        return null;
    }

    return (
        <div id="AnnouncementBanner" className="announcement-banner" role="alert">
            <div className="announcement-banner__container">
                <div className="announcement-banner__icon ms-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2 1 21h22L12 2zm0 4.5L19.5 19h-15L12 6.5zM11 10v5h2v-5h-2zm0 6v2h2v-2h-2z" />
                    </svg>
                </div>
                <p className="announcement-banner__text">
                    Please be aware that <strong>xsd.milestonesys.com</strong> will be decommissioned on October 1.
                    All designs created and edited in XSD before 09:00 CEST (UTC+2) on Monday, 6 July 2026 will be
                    migrated automatically to Milestone Solution Designer:{" "}
                    <a
                        className="announcement-banner__link"
                        href={MSD_URL}
                        target="_blank"
                        rel="noopener noreferrer">
                        msd.milestonesys.com
                    </a>
                    , so you can continue working with your projects without interruption. All designs created and
                    edited in XSD after 09:00 CEST (UTC+2) on Monday, 6 July 2026 can be exported from XSD to MSD with
                    export functionality from 18th of August 2026. Please update any bookmarks accordingly.
                </p>
                <button
                    id="xsd__e2e-announcement-banner-close"
                    type="button"
                    className="announcement-banner__close"
                    aria-label="Dismiss announcement"
                    onClick={() => setDismissed(true)}>
                    <svg viewBox="0 0 128 128" version="1.1" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M63.646 54.433L99.079 19 109 28.921 73.567 64.354 108.29 99.08 98.371 109 63.645 74.276 29.63 108.29l-9.921-9.92 34.015-34.017L19 29.63l9.921-9.921z" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default AnnouncementBanner;
